import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => {
  try {
    const raw = localStorage.getItem('userData')
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const TWO_FA_SETUP_TTL_MS = 30 * 60 * 1000

export const clearTwoFaSetupSession = () => {
  sessionStorage.removeItem('twoFaSetupToken')
  sessionStorage.removeItem('twoFaSetupAccountType')
  sessionStorage.removeItem('twoFaSetupTokenAt')
}

export const storeTwoFaSetupSession = (token, accountType) => {
  sessionStorage.setItem('twoFaSetupToken', token)
  sessionStorage.setItem('twoFaSetupAccountType', accountType)
  sessionStorage.setItem('twoFaSetupTokenAt', String(Date.now()))
}

export const getTwoFaSetupSession = () => {
  const token = sessionStorage.getItem('twoFaSetupToken')
  const accountType = sessionStorage.getItem('twoFaSetupAccountType')
  const createdAt = Number(sessionStorage.getItem('twoFaSetupTokenAt') || 0)

  if (!token || !accountType) {
    clearTwoFaSetupSession()
    return null
  }

  if (!createdAt || Date.now() - createdAt > TWO_FA_SETUP_TTL_MS) {
    clearTwoFaSetupSession()
    return null
  }

  return { token, accountType }
}

export const isTwoFaSetupSessionActive = () => !!getTwoFaSetupSession()

export const clearAdminTwoFaSession = () => {
  sessionStorage.removeItem('adminTwoFaOk')
  clearTwoFaSetupSession()
}

export const needsAdminTwoFactor = (userData) => {
  if (!userData) return false
  if (userData.usertype === 'member') return false
  const skipRoles = ['member', 'seamless', 'banhuay']
  if (skipRoles.includes(userData.role)) return false
  return true
}

export const logoutLocalSession = () => {
  clearAdminTwoFaSession()
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
  localStorage.removeItem('userData')
  localStorage.removeItem('SearchItems')
  localStorage.removeItem('username_agent')
  localStorage.removeItem('UserToken')
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole, path) => {
  if (userRole === 'master') return '/dashboard'
  if (userRole === 'agadmin') return '/dashboard'
  if (userRole === 'agline') return '/dashboard'
  if (userRole === 'agseamless') return '/manage-lotto-status'
  if (userRole === 'admin') return '/dashboard'
  if (userRole === 'seamless') return '/tanghuay-round'
  if (userRole === 'member') return '/tanghuay-round'

  if (userRole === 'user') return '/'
  if (userRole === 'SubAccount') return path
  if (userRole === 'AGgroup') return '/LottoAgent'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
